<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h2>ล็อคผล</h2>
      </div>
      <div class="card-body">
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-select
              v-model="query.slugAdd"
              :items="slugList"
              item-text="name"
              item-value="slug"
              label="เลือกประเภทเกมส์"
              outlined
              @change="getGameLists"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-select
              v-model="query.gameId"
              :items="gameList"
              item-text="name"
              item-value="id"
              label="เลือกรอบเกมส์"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              v-model="result"
              align="center"
              label="กรอกเลข5หลัก"
              outlined
              pattern="\d{5,5}"
              maxlength="5"
              min="5"
              required
              @keypress="validateNumber($event)"
            />
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-btn
              color="success"
              large
              @click="addResult"
            >
              <v-icon>mdi-plus</v-icon>
              เพิ่ม
            </v-btn>
            <v-btn
              color="info"
              large
              @click="displayDigits()"
            >
              <v-icon>mdi-digit</v-icon>
              ดูเลข
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="card mt-5">
      <div class="card-header">
        <h2>เช็คผลล็อค</h2>
      </div>
      <div class="card-body">
        <v-row>
          <v-col
            cols="12"
            sm="5"
          >
            <v-select
              v-model="query.slug"
              :items="slugList"
              item-text="name"
              item-value="slug"
              label="เลือกประเภทเกมส์"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            sm="5"
          >
            <v-menu
              ref="showDateDialog"
              v-model="showDateDialog"
              :close-on-content-click="false"
              :return-value.sync="dateSelect"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSelectDisplay"
                  label="วันที่"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateSelect"
                no-title
                @change="
                  $refs.showDateDialog.save(dateSelectDisplay);
                  showDateDialog = false;
                "
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-btn
              color="primary"
              large
              @click="fetchData(query.slug)"
            >
              <v-icon left>
                mdi-check
              </v-icon>
              ค้นหา
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :footer-props="footer"
          :headers="headers"
          :items.sync="items"
          :loading="loading"
          :multi-sort="false"
          :options.sync="options"
          :server-items-length="totalItems"
          class="elevation-0"
          item-key="id"
        >
          <!-- item -->
          <template #item.game_name="{ item }">
            <a
              :href="'/admin/lotto/approve/' + item.id"
              target="blank"
            ><span class="text-danger">{{ item.master.name }} {{ item.readable_edition }}
              {{ item.game_thai_date }}</span></a>
          </template>
          <template #item.status="{ item }">
            <v-chip
              v-if="item.status == 'open'"
              class="ma-2"
              color="green"
              outlined
            >
              เปิดรับแทง
            </v-chip>

            <v-chip
              v-else-if="item.status == 'pending'"
              class="ma-2"
              color="blue"
              outlined
            >
              เกมส์ยังไม่เปิด
            </v-chip>
            <v-chip
              v-else
              class="ma-2"
              color="red"
              outlined
            >
              เกมส์จบแล้ว
            </v-chip>
          </template>
          <template #item.result="{ item }">
            {{
              item.result_limit ? item.result_limit.digits : "ไม่มีการล็อคผล"
            }}
          </template>
          <template #item.user="{ item }">
            {{ item.result_limit.user.name }}
          </template>
          <template #item.created_at="{ item }">
            <span
              v-if="item.created_at"
              class="d-block"
            >
            {{  item.created_at}}
          </span>
          </template>

          <template #item.manage="{ item }">
            <div
              v-if="
                ($moment().valueOf() - $moment(item.close_at).valueOf()) /
                  1000 <
                  30
              "
            >
              <v-btn
                color="warning"
                @click="delResult(item.id)"
              >
                <v-icon>mdi-delete</v-icon>
                ลบ
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog
      v-model="digitsItem"
      width="700"
      max-width="100vw"
      persistent
    >
      <v-card>
        <v-toolbar
          color="red"
          height="55"
        >
          <v-card-title class="pa-0">
            <span class="text-body-1 text-uppercase text-light">ดูเลข</span>
          </v-card-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click="closeDialog()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div
          class="
            d-flex
            text-md
            font-weight-bold
            py-1
            border-top
            bg-black
            text-white
          "
        >
          <div
            class="text-center border-right"
            style="width: 40%"
          >
            <div class="text-monospace">
              เลข
            </div>
          </div>
          <div
            class="text-center border-right"
            style="width: 30%"
          >
            <div class="text-monospace">
              ยอดแทง
            </div>
          </div>
          <div
            class="text-center"
            style="width: 30%"
          >
            <div class="text-monospace">
              จ่าย
            </div>
          </div>
        </div>

        <div
          v-for="(item, index) in digitsList"
          :key="index"
        >
          <div class="d-flex text-lg py-1 border-top">
            <div
              class="border-right"
              style="width: 40%"
            >
              <div class="text-center text-md">
                {{ item.digits }}
                <span>
                  <i :class="iconType(item.slug)" />
                </span>
              </div>
            </div>
            <div
              class="border-right"
              style="width: 30%"
            >
              <div class="text-center text-md">
                {{ Intl.NumberFormat("en-US").format(item.amount) }}
              </div>
            </div>
            <div style="width: 30%">
              <div class="text-center text-md">
                {{ Intl.NumberFormat("en-US").format(item.prize) }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment-timezone';

export default {
  name: 'AdminResultLimit',
  props: {
    slugList: { default: [], Type: Array },
  },
  data() {
    return {
      footer: {
        itemsPerPageOptions: [50, 100],
      },
      loading: true,
      search: false,
      sortable: false,
      headers: [
        {
          text: 'ชื่อเกมส์',
          value: 'game_name',
          align: 'left',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'ผล',
          value: 'result',
          align: 'center',
          sortable: false,
        },
        {
          text: 'ผู้จัดการ',
          value: 'user',
          align: 'center',
          justify: 'center',
          sortable: false,
        },

        {
          text: 'วันที่',
          value: 'created_at',
          align: 'center',
          sortable: false,
        },
        {
          text: 'จัดการ',
          value: 'manage',
          align: 'center',
          sortable: false,
          searchable: false,
        },
      ],
      items: [],
      totalItems: 0,
      options: {},
      query: {
        slugAdd: null,
        slug: null,
        gameId: null,
      },
      result: null,
      preload: false,
      showDateDialog: false,
      dateSelect: moment().format('YYYY-MM-DD'),
      gameList: [],
      digitsItem: null,
      digitsList: [],
    };
  },
  computed: {
    dateSelectDisplay() {
      return this.dateSelect;
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },

  mounted() {},

  methods: {
    fetchData(slug) {
      this.loading = true;

      var slug = slug || 'soidown';
      axios
        .get(`/admin/game/limit/${slug}`, {
          params: {
            page: this.options.page,
            sortBy: this.options.sortBy[0],
            sortDirection:
              this.options.sortDesc.length > 0
                ? this.options.sortDesc[0]
                  ? 'ASC'
                  : 'DESC'
                : null,
            dateRound: this.dateSelect,
            pageSize: this.options.itemsPerPage,
          },
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalItems = response.data.total;
        })
        .catch((error) => {
          if (error.response.status == 409) {
            Vue.$toast.open({
              message: 'ไม่มีสิทธิ์ใช้งาน',
              type: 'error',
              duration: 5000,
              position: 'top-right',
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getGameLists() {
      const link = `/api/getGameLists/${this.query.slugAdd}`;

      this.preload = true;
      axios
        .get(link)
        .then((response) => {
          Vue.set(this, 'gameList', response.data);
        })
        .finally(() => {
          this.preload = false;
        });
    },

    displayDigits() {
      const link = `/admin/game/limit/low/${this.query.gameId}`;
      const self = this;
      this.preload = true;
      axios
        .get(link)
        .then((response) => {
          self.digitsList = response.data.all;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.digitsItem = true;
          this.preload = false;
        });
    },

    addResult() {
      this.preload = true;

      const conf = confirm('ต้องการเพิ่มผลเกมส์นี้ใช่ไหม');
      if (conf) {
        axios
          .post('/admin/game/limit', {
            params: {
              gameId: this.query.gameId,
              result: this.result,
            },
          })
          .then((response) => {
            if (response.status == 200) {
              Vue.$toast.open({
                message: 'บันทึกสำเร็จ',
                type: 'success',
                duration: 5000,
                position: 'top-right',
              });
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
              Vue.$toast.open({
                message: 'ไม่สามารถบันทึกได้กรุณาลองใหม่',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else if (error.response.status == 406) {
              Vue.$toast.open({
                message: 'เกมส์จบหรือออกผลแล้ว',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else if (error.response.status == 409) {
              Vue.$toast.open({
                message: 'ไม่มีสิทธิ์ใช้งาน',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else {
              Vue.$toast.open({
                message: 'ไม่สามารถบันทึกได้กรุณาลองใหม่',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            }
          })
          .finally(() => {
            this.fetchData(this.query.slugAdd);
            this.preload = false;
          });
      }
    },

    delResult(id) {
      const conf = confirm('ต้องการลบผลเกมส์นี้ใช่ไหม');
      if (conf) {
        axios
          .delete(`/admin/game/limit/${id}`)
          .then((response) => {
            if (response.status == 200) {
              Vue.$toast.open({
                message: 'ลบสำเร็จ',
                type: 'success',
                duration: 5000,
                position: 'top-right',
              });
            }
          })
          .catch((error) => {
            if (error.response.status == 409) {
              Vue.$toast.open({
                message: 'ไม่มีสิทธิ์ใช้งาน',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else if (error.response.status == 406) {
              Vue.$toast.open({
                message: 'ปิดการแก้ไข',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else {
              Vue.$toast.open({
                message: 'ไม่สามารถลบได้กรุณาลองใหม่',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            }
          })
          .finally(() => {
            this.fetchData(this.query.slug);
            this.preload = false;
          });
      }
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    closeDialog() {
      this.digitsItem = false;
      this.digitsList = [];
    },

    iconType(slug) {
      switch (slug) {
        case '4upper':
          return '';
        case '3upper':
          return 'fas fa-arrow-up';
        case '3shuffle':
          return 'fas fa-sync-alt';
        case '3front':
          return 'fas fa-arrow-left';
        case '3back':
          return 'fas fa-arrow-right';
        case '2upper':
          return 'fas fa-arrow-up';
        case '2under':
          return 'fas fa-arrow-down';
        case 'any_upper':
          return 'fas fa-arrow-up';
      }
    },
  },
};
</script>
